
import Axios from "./CallerService"
export const createProposal = (data) => {
    return Axios.post(`proposals`, data)
}

export const validateProposal = (proposalId) => {
    const data = {notrigger:1}
    return Axios.post(`proposals/${proposalId}/validate`,data)
}